var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"viewDetails",on:{"click":_vm.linktohref}},[_c('div',{staticClass:"viewDetailsText"},[_vm._v("查看详情")]),_vm._v(" "),_c('div',{staticClass:"viewDetailsShu"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba643008","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/indextitle.vue
// module id = Xha8
// module chunks = 1